import React from "react"
import ReactDOM from "react-dom"
import ParkingProductBookingStarterComponent from "./ParkingProductBookingStarterComponent"

export default class ParkingProductBookingStarterModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.productData = {}
    if (elem.dataset.parkingProductBookingstarter) {
      self.productData = JSON.parse(elem.dataset.parkingProductBookingstarter)
    }
    this.init()
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<ParkingProductBookingStarterComponent container={self.elem} productData={self.productData} />, self.elem)
  }
}
